import { render } from "./ComplexStatisticsCard.vue?vue&type=template&id=f1377204"
import script from "./ComplexStatisticsCard.vue?vue&type=script&lang=js"
export * from "./ComplexStatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__